import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-lead-status-dialog',
  templateUrl: './edit-lead-status-dialog.component.html',
  styleUrls: ['./lead-status.component.css']
})
export class EditLeadStatusDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EditLeadStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close({ action: 'save', model: this.data.model });
  }

}
